import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className={`ri-book-open-line text-2xl ${scrolled || !isHome ? 'text-primary-500' : 'text-white'}`}></i>
            </div>
            <span className={`font-heading text-xl font-bold tracking-wide ${scrolled || !isHome ? 'text-foreground-900' : 'text-white'}`}>
              韩漫之家
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                location.pathname === '/'
                  ? scrolled || !isHome ? 'text-primary-500' : 'text-white font-bold'
                  : scrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-white/80 hover:text-white'
              }`}
            >
              首页
            </Link>

            <div className="relative">
              <button
                onClick={() => setCategoryOpen(!categoryOpen)}
                className={`flex items-center gap-1 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                  location.pathname.startsWith('/category')
                    ? scrolled || !isHome ? 'text-primary-500' : 'text-white font-bold'
                    : scrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-white/80 hover:text-white'
                }`}
              >
                分类
                <i className={`ri-arrow-down-s-line transition-transform ${categoryOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {categoryOpen && (
                <div className="absolute top-full mt-2 left-1/2 -translate-x-1/2 bg-background-50 rounded-lg py-2 min-w-[200px] z-50 shadow-sm border border-background-200/70">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      <span className="w-5 h-5 flex items-center justify-center">
                        <i className={`${cat.icon} text-base`}></i>
                      </span>
                      {cat.name}
                      <span className="ml-auto text-xs text-foreground-400">{cat.count}部</span>
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                location.pathname === '/about'
                  ? scrolled || !isHome ? 'text-primary-500' : 'text-white font-bold'
                  : scrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-white/80 hover:text-white'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer transition-colors bg-background-100 hover:bg-background-200">
              <i className={`ri-search-line ${scrolled || !isHome ? 'text-foreground-600' : 'text-white'}`}></i>
            </button>
            <Link
              to="/about"
              className="bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-5 py-2 rounded-md whitespace-nowrap cursor-pointer transition-colors"
            >
              开始阅读
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
          >
            <i className={`ri-menu-line text-2xl ${scrolled || !isHome ? 'text-foreground-800' : 'text-white'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-2">
            <Link to="/" className="text-sm text-foreground-700 py-2 cursor-pointer">首页</Link>
            <div className="text-sm text-foreground-500 py-2 font-medium">分类</div>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-2 text-sm text-foreground-600 pl-3 py-1.5 cursor-pointer"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className={`${cat.icon} text-xs`}></i>
                </span>
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="text-sm text-foreground-700 py-2 cursor-pointer">关于我们</Link>
            <Link to="/about" className="bg-primary-500 text-background-50 text-sm font-medium px-5 py-2.5 rounded-md text-center cursor-pointer mt-1">
              开始阅读
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}